import Vue from 'vue'
import LocaleSettings from 'FrontComponents/vue/LocaleSettings/Index.vue'
import { store } from '../../components/front/vue/store/store'

if (document.querySelector('#locale-settings')) {
    // const LocaleSettings = () => import(/* webpackChunkName: "assets/locale-settings" */ 'FrontComponents/vue/LocaleSettings/Index.vue')

    new Vue({
        el: '#locale-settings',
        store,
        components: {
            LocaleSettings,
        },
    })
}
